import styled from 'styled-components';
import RestroSvg from '../../assets/amenities/restro.svg';

const RestroIcon = styled(RestroSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default RestroIcon;
